import * as React from 'react';
import { get } from 'lodash-es';
import CancelationReasons from '@sunbit-dev/common/enums/CancelationReasons';
import ActionTypes from '../constants/actionTypes';
import { errors, fallbackError } from '../constants/errors';

interface IErrorState {
  type: string;
  isModal: boolean;
  title: string;
  description: string;
  buttonTitle: string;
  code: string;
  show: boolean;
  cancelApplication: boolean;
  cancelationReason?: CancelationReasons;
}

type Action = { type: ActionTypes; error: { code: string } };

function getInitialState(): IErrorState {
  return {
    type: '',
    isModal: false,
    title: '',
    description: '',
    buttonTitle: 'ok',
    show: false,
    code: '',
    cancelApplication: false,
  };
}

export function getError(action: ActionTypes, code: string) {
  return get(errors, [action, code], fallbackError);
}

const errorReducer = (state: IErrorState, action: Action) => {
  let error;
  switch (action.type) {
    case ActionTypes.ActionLoginToCheckout:
    case ActionTypes.ActionCreateCheckoutCustomer:
    case ActionTypes.ActionCreateCheckoutPurchase:
    case ActionTypes.ActionValidateDebitCard:
    case ActionTypes.ActionVerifySSN:
    case ActionTypes.ActionShowError:
    case ActionTypes.ExtraVerification:
      const errorCode = action.error.code!! ? action.error.code : 'ActionShowError';
      error = getError(action.type, errorCode);
      return { ...state, ...error, show: error.isModal };
    case ActionTypes.ActionClearError:
      return getInitialState();
    default:
      return { ...state, show: false };
  }
};

export const ErrorStateContext = React.createContext<IErrorState>(getInitialState());

export const ErrorDispatchContext = React.createContext<React.Dispatch<any>>(() => null);

const ErrorContextProvider = (props) => {
  const [state, dispatch] = React.useReducer(errorReducer, getInitialState());

  return (
    <ErrorDispatchContext.Provider value={dispatch}>
      <ErrorStateContext.Provider value={state}>{props.children}</ErrorStateContext.Provider>
    </ErrorDispatchContext.Provider>
  );
};

export default ErrorContextProvider;
